/** 生成默认名称，沿用作品名的本地时间“月份 + 星期 + 小时”六位数字后缀。 */
export function createDefaultName(prefix: string, now = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, '0')
  // 历史作品名使用星期（周日为 00），复用时保持该语义，避免改变现有作品命名。
  const weekday = String(now.getDay()).padStart(2, '0')
  const hour = String(now.getHours()).padStart(2, '0')
  return `${prefix}${month}${weekday}${hour}`
}
